<template>
  <v-row
    justify="start"
    align="center"
  >
    <v-col cols="6">
      <v-btn
        v-if="displayRemove(position)"
        id="removeItem"
        icon
        color="primary"
        width="50"
        height="50"
        @click="removeItem(position)"
      >
        <v-icon size="45">
          mdi-minus-circle
        </v-icon>
      </v-btn>
    </v-col>
    <v-col cols="6">
      <v-btn
        v-if="isLastItem(position)"
        id="addItem"
        icon
        color="#2ABD49"
        width="50"
        height="50"
        @click="addItem()"
      >
        <v-icon size="45">
          mdi-plus-circle
        </v-icon>
      </v-btn>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'RemoveAddButtons',
  props: {
    position: {
      type: Number,
      required: true,
    },
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    items() {
      return this.value;
    },
    isLastItem() {
      return (pos) => pos === (this.items.length - 1);
    },
    displayRemove() {
      return (idx) => this.items.length > 1 && idx >= 0;
    },
  },
  methods: {
    removeItem(position) {
      this.$emit('remove', position);
    },
    addItem(position) {
      this.$emit('add', position);
    },
  },
};
</script>
